/**
 * BE BOLD : Path A: Strengthen and Build
 * Month 2: Foundation Strength (Days 31-60)
 *
 * Squeeze 50-60%, hold 5-8s. Pulsacao introduced.
 *
 * All sessions verified at 300s +/-20s (5 minutes)
 * Generated: 2026-04-13 02:14
 *
 * bebold.au | Paula Tomazetti | 16+ years of study
 * All content is 100% Be Bold.
 */

export const exercises = {

  belly_breath_drop: {
    id: 'belly_breath_drop',
    name: 'Belly Breath Drop',
    name_pt: 'Respiro da Barriga',
    sub: 'The floor drops on the inhale. Stay soft on the exhale.',
    sub_pt: 'O assoalho cai na inspiração. Fique macia na expiração.',
    level: 'Release',
    zone: 'Full floor 0-3cm',
    color: '#7A5A6A',
    movement: 'release',
    inst: `Lie on your back with your knees bent and feet flat. Place one hand on your lower belly.

Inhale slowly through your nose for 4 counts. Feel your belly rise under your hand. Your pelvic floor drops gently as your belly expands. You do not push it. It falls on its own.

Exhale through your mouth for 6 counts. Stay soft. Nothing tightens on the exhale. The floor stays dropped.

If you feel nothing at first, that is your starting point.

Picture it: your pelvic floor is a hammock between two trees. Each inhale, the hammock sinks wider. Each exhale, it stays low.`,
    inst_pt: `Deite de costas com os joelhos dobrados e pés apoiados. Coloque uma mão na barriga baixa.

Inspire lentamente pelo nariz por 4 tempos. Sinta a barriga subir sob sua mão. Seu assoalho pélvico desce suavemente conforme a barriga expande. Você não empurra. Ele cai sozinho.

Expire pela boca por 6 tempos. Fique macia. Nada contrai na expiração. O assoalho continua solto.

Se não sentir nada no início, esse é seu ponto de partida.

Visualize: seu assoalho pélvico é uma rede entre duas árvores. Cada inspiração, a rede afunda e alarga. Cada expiração, ela fica baixa.`,
    breathe: 'Inhale 4 counts to drop. Exhale 6 counts to stay soft.',
    breathe_pt: 'Inspire 4 tempos para soltar. Expire 6 tempos para ficar macia.',
    timerCue: `Inhale.
Drop.
Exhale.
Stay soft.`,
    timerCue_pt: `Inspire.
Solte.
Expire.
Fique macia.`,
    feel: 'A subtle widening and heaviness in the pelvic bowl on every inhale. Nothing tense. Nothing forced.',
    feel_pt: 'Uma sutil abertura e peso na pelve a cada inspiração. Nada tenso. Nada forçado.',
    avoid: 'Do not push the floor down. Do not bear down. Do not tighten on the exhale.',
    avoid_pt: 'Não empurre o assoalho para baixo. Não faça força. Não contraia na expiração.',
    type: 'hold',
    sets: 15,
    hold: 4,
    relax: 6,
    rest: 0,
  },

  child_pose_release: {
    id: 'child_pose_release',
    pose: 'child-pose',
    name: 'Child Pose Release',
    name_pt: 'Soltura na Posição Criança',
    sub: 'The deepest passive stretch for a tight floor.',
    sub_pt: 'O alongamento passivo mais profundo para um assoalho tenso.',
    level: 'Release',
    zone: 'Full floor 0-6cm',
    color: '#7A5A6A',
    movement: 'release',
    inst: `Kneel on a soft surface. Bring your knees wide apart. Sit back onto your heels. Stretch your arms forward on the floor.

Let your forehead rest on the floor or on a pillow. Let your belly hang between your thighs.

Inhale for 4 counts. Feel your belly expand toward the floor. Your pelvic floor lengthens between your sit bones.

Exhale for 6 counts. Let everything drop heavier. Gravity pulls your belly down and your floor opens.

Stay here for the full time. No effort. No movement. Just breathing into the stretch.

Picture it: a cat stretching after a nap. Front paws forward, hips back, belly dropped. Total surrender. Or draping a wet towel over a round surface. The towel has no shape of its own. It just falls over whatever is underneath.`,
    inst_pt: `Ajoelhe numa superfície macia. Abra os joelhos bem. Sente nos calcanhares. Estique os braços para frente no chão.

Deixe a testa descansar no chão ou num travesseiro. Deixe a barriga pendurar entre as coxas.

Inspire por 4 tempos. Sinta a barriga expandir em direção ao chão. Seu assoalho pélvico se alonga entre os ísquios.

Expire por 6 tempos. Deixe tudo cair mais pesado. A gravidade puxa a barriga para baixo e seu assoalho abre.

Fique aqui pelo tempo todo. Sem esforço. Sem movimento. Apenas respirando no alongamento.

Visualize: um gato se espreguiçando depois da soneca. Patas dianteiras para frente, quadril para trás, barriga caída. Rendição total. Ou cobrindo uma superfície arredondada com uma toalha molhada. A toalha não tem forma própria. Apenas cai.`,
    breathe: 'Inhale to lengthen. Exhale to surrender.',
    breathe_pt: 'Inspire para alongar. Expire para se render.',
    timerCue: `Inhale.
Lengthen.
Exhale.
Surrender.`,
    timerCue_pt: `Inspire.
Alongue.
Expire.
Rendição.`,
    feel: 'Deep opening across the entire pelvic floor. The belly hangs. The floor stretches.',
    feel_pt: 'Abertura profunda em todo o assoalho pélvico. A barriga pendura. O assoalho se alonga.',
    avoid: 'Do not bear down. If knees hurt, cushion between calves and thighs.',
    avoid_pt: 'Não faça força. Se joelhos doem, almofada entre panturrilhas e coxas.',
    type: 'timed',
    sets: 1,
    hold: 150,
    rest: 0,
  },

  gentle_push_reset: {
    id: 'gentle_push_reset',
    name: 'Gentle Push Reset',
    name_pt: 'Reset Suave',
    sub: 'After every squeeze set, 3 pushes confirm rest.',
    sub_pt: 'Após cada série de aperto, 3 empurrões confirmam repouso.',
    level: 'Foundation',
    zone: 'Full floor 0-3cm',
    color: '#8A6A7A',
    movement: 'push',
    inst: `After your squeeze set, exhale and gently push the pelvic floor downward. 15% effort. Hold 4 seconds. Release. Repeat 3 times. This confirms the floor returned to true rest.

Picture it: pressing reset on a stopwatch. Three clicks and you are back to zero.`,
    inst_pt: `Após sua série de aperto, expire e empurre suavemente o assoalho para baixo. 15% esforço. Segure 4 segundos. Solte. Repita 3 vezes. Isso confirma repouso real.

Visualize: apertando reset num cronômetro. Três cliques e volta ao zero.`,
    breathe: 'Exhale to push. Inhale to release.',
    breathe_pt: 'Expire para empurrar. Inspire para soltar.',
    timerCue: `Exhale.
Push.
Release.`,
    timerCue_pt: `Expire.
Empurre.
Solte.`,
    feel: 'Gentle downward opening after each squeeze set.',
    feel_pt: 'Abertura suave para baixo após cada série de aperto.',
    avoid: 'Do not skip after squeeze exercises. Do not strain.',
    avoid_pt: 'Não pule após exercícios de aperto. Não force.',
    type: 'hold',
    sets: 15,
    hold: 4,
    relax: 6,
    rest: 0,
  },

  pulsacao: {
    id: 'pulsacao',
    name: 'Pulsação',
    name_pt: 'Pulsação',
    sub: '1 second on, 1 second off. Clean rhythm. Each rep starts fresh.',
    sub_pt: '1 segundo liga, 1 segundo desliga. Ritmo limpo. Cada repetição começa limpa.',
    level: 'Foundation',
    zone: 'Full floor 0-3cm',
    color: '#8B4A5A',
    movement: 'squeeze',
    inst: `Sit with feet flat. CLOSE and SQUEEZE for 1 second. Release completely for 1 second. That is one rep.

Each contraction is independent. Do not let tension accumulate across reps. The release is 50% of the exercise.

After each set, do 3 Gentle Pushes to confirm full rest.

Picture it: a camera shutter. Click open, click closed. Sharp and complete. No blur between open and closed.`,
    inst_pt: `Sente com pés apoiados. FECHE e APERTE por 1 segundo. Solte completamente por 1 segundo. Isso é uma repetição.

Cada contração é independente. Não deixe tensão acumular. A soltura é 50% do exercício.

Após cada série, faça 3 Empurrões Suaves para confirmar repouso.

Visualize: obturador de câmera. Clique abre, clique fecha. Nítido e completo. Sem borrão.`,
    breathe: 'Exhale to squeeze. Inhale to release.',
    breathe_pt: 'Expire para apertar. Inspire para soltar.',
    timerCue: `Squeeze.
Release.`,
    timerCue_pt: `Aperte.
Solte.`,
    feel: 'Clean on-off rhythm. Release as complete as contraction.',
    feel_pt: 'Ritmo liga-desliga limpo. Soltura tão completa quanto contração.',
    avoid: 'Do not let tension build across reps. Do not bear down.',
    avoid_pt: 'Não deixe tensão acumular entre repetições. Não faça força.',
    type: 'pulse',
    sets: 5,
    rest: 10,
    reps: 12,
    on: 1,
    off: 1,
  },

  squeeze_5s: {
    id: 'squeeze_5s',
    name: 'Foundation Squeeze 5s',
    name_pt: 'Aperto Base 5s',
    sub: 'CLOSE and SQUEEZE at 50%. Hold 5 seconds.',
    sub_pt: 'FECHE e APERTE em 50%. Segure 5 segundos.',
    level: 'Foundation',
    zone: 'Full floor 0-3cm',
    color: '#8B4A5A',
    movement: 'squeeze',
    inst: `Lie down or sit. CLOSE and SQUEEZE at 50% effort. Hold 5 seconds. Breathe normally. Release completely for 5 seconds.

The muscle should hold steady for the full 5 seconds. If it fades at 3 seconds, that IS your current limit. Build from there.

Picture it: holding a glass of water steady for 5 seconds, then setting it down. Controlled up and controlled down.`,
    inst_pt: `Deite ou sente. FECHE e APERTE com 50% esforço. Segure 5 segundos. Respire normal. Solte completamente por 5 segundos.

O músculo deve se manter firme por 5 segundos. Se enfraquecer em 3 segundos, esse É seu limite atual. Construa a partir daí.

Visualize: segurando copo d'água firme por 5 segundos, depois colocando. Controlado sobe e controlado desce.`,
    breathe: 'Exhale to engage. Breathe normally while holding.',
    breathe_pt: 'Expire para engajar. Respire normal enquanto segura.',
    timerCue: `Squeeze.
Hold 5.
Release.`,
    timerCue_pt: `Aperte.
Segure 5.
Solte.`,
    feel: 'Definite lift and a steady hold. The lift stays clear from start to finish.',
    feel_pt: 'Elevação e sustentação definida. A elevação permanece clara do início ao fim.',
    avoid: 'Do not hold breath. Do not bear down. Do not compensate.',
    avoid_pt: 'Não prenda respiração. Não faça força. Não compense.',
    type: 'hold',
    sets: 15,
    hold: 5,
    relax: 5,
    rest: 0,
  },

  squeeze_8s: {
    id: 'squeeze_8s',
    name: 'Strong Hold 8s',
    name_pt: 'Sustentação Forte 8s',
    sub: '60% effort. 8 seconds. The last 2 seconds build strength.',
    sub_pt: '60% esforço. 8 segundos. Os últimos 2 segundos constroem força.',
    level: 'Foundation',
    zone: 'Full floor 0-3cm',
    color: '#8B4A5A',
    movement: 'squeeze',
    inst: `Lie down or sit. CLOSE and SQUEEZE at 60%. Hold 8 seconds. Breathe normally. The muscle should hold without fading. If it fades at 5 seconds, that is your edge. The edge is where growth happens.

Release completely for 8 seconds.

Picture it: holding a plank. Your body shakes at the limit. That shake is strength building.`,
    inst_pt: `Deite ou sente. FECHE e APERTE em 60%. Segure 8 segundos. Respire normal. O músculo deve se manter. Se enfraquecer em 5 segundos, esse é seu limite. O limite é onde o crescimento acontece.

Solte completamente por 8 segundos.

Visualize: segurando prancha. Corpo treme no limite. Tremor é força construindo.`,
    breathe: 'Exhale to engage. Breathe while holding.',
    breathe_pt: 'Expire para engajar. Respire enquanto segura.',
    timerCue: `Squeeze.
Hold 8.
Release.`,
    timerCue_pt: `Aperte.
Segure 8.
Solte.`,
    feel: 'Strong sustained lift. A trembling or harder pull near the end of the hold.',
    feel_pt: 'Elevação sustentada forte. Tremor ou puxada mais intensa perto do fim da sustentação.',
    avoid: 'Do not hold breath. Do not bear down. Do not compensate with glutes.',
    avoid_pt: 'Não prenda respiração. Não faça força. Não compense com glúteos.',
    type: 'hold',
    sets: 10,
    hold: 8,
    relax: 8,
    rest: 0,
  },
};

export const days = [
  {
    day: 31, week: 5,
    title: 'Day 31', title_pt: 'Dia 31',
    exercises: [
      { ref: 'child_pose_release', overrides: {"hold": 100.0} }, // 100.0s
      { ref: 'squeeze_5s', overrides: {"sets": 10} }, // 100s
      { ref: 'squeeze_8s', overrides: {"sets": 6} }, // 96s
    ], // Total: 296.0s = 4.9 min
  },
  {
    day: 32, week: 5,
    title: 'Day 32', title_pt: 'Dia 32',
    exercises: [
      { ref: 'squeeze_5s', overrides: {} }, // 150s
      { ref: 'squeeze_8s', overrides: {"sets": 9} }, // 144s
    ], // Total: 294s = 4.9 min
  },
  {
    day: 33, week: 5,
    title: 'Day 33', title_pt: 'Dia 33',
    exercises: [
      { ref: 'belly_breath_drop', overrides: {"sets": 10} }, // 100s
      { ref: 'pulsacao', overrides: {"sets": 3} }, // 92s
      { ref: 'gentle_push_reset', overrides: {"sets": 11} }, // 110s
    ], // Total: 302s = 5.0 min
  },
  {
    day: 34, week: 5,
    title: 'Day 34', title_pt: 'Dia 34',
    exercises: [
      { ref: 'gentle_push_reset', overrides: {"sets": 10} }, // 100s
      { ref: 'child_pose_release', overrides: {"hold": 100.0} }, // 100.0s
      { ref: 'belly_breath_drop', overrides: {"sets": 10} }, // 100s
    ], // Total: 300.0s = 5.0 min
  },
  {
    day: 35, week: 5,
    title: 'Day 35', title_pt: 'Dia 35',
    exercises: [
      { ref: 'belly_breath_drop', overrides: {} }, // 150s
      { ref: 'child_pose_release', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 36, week: 6,
    title: 'Day 36', title_pt: 'Dia 36',
    exercises: [
      { ref: 'child_pose_release', overrides: {"hold": 100.0} }, // 100.0s
      { ref: 'gentle_push_reset', overrides: {"sets": 10} }, // 100s
      { ref: 'belly_breath_drop', overrides: {"sets": 10} }, // 100s
    ], // Total: 300.0s = 5.0 min
  },
  {
    day: 37, week: 6,
    title: 'Day 37', title_pt: 'Dia 37',
    exercises: [
      { ref: 'child_pose_release', overrides: {} }, // 150s
      { ref: 'squeeze_5s', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 38, week: 6,
    title: 'Day 38', title_pt: 'Dia 38',
    exercises: [
      { ref: 'squeeze_8s', overrides: {"sets": 6} }, // 96s
      { ref: 'belly_breath_drop', overrides: {"sets": 10} }, // 100s
      { ref: 'pulsacao', overrides: {"sets": 3} }, // 92s
    ], // Total: 288s = 4.8 min
  },
  {
    day: 39, week: 6,
    title: 'Day 39', title_pt: 'Dia 39',
    exercises: [
      { ref: 'gentle_push_reset', overrides: {} }, // 150s
      { ref: 'squeeze_5s', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 40, week: 6,
    title: 'Day 40', title_pt: 'Dia 40',
    exercises: [
      { ref: 'squeeze_8s', overrides: {"sets": 9} }, // 144s
      { ref: 'belly_breath_drop', overrides: {"sets": 16} }, // 160s
    ], // Total: 304s = 5.1 min
  },
  {
    day: 41, week: 6,
    title: 'Day 41', title_pt: 'Dia 41',
    exercises: [
      { ref: 'gentle_push_reset', overrides: {} }, // 150s
      { ref: 'belly_breath_drop', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 42, week: 6,
    title: 'Day 42', title_pt: 'Dia 42',
    exercises: [
      { ref: 'belly_breath_drop', overrides: {} }, // 150s
      { ref: 'gentle_push_reset', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 43, week: 7,
    title: 'Day 43', title_pt: 'Dia 43',
    exercises: [
      { ref: 'squeeze_5s', overrides: {} }, // 150s
      { ref: 'squeeze_8s', overrides: {"sets": 9} }, // 144s
    ], // Total: 294s = 4.9 min
  },
  {
    day: 44, week: 7,
    title: 'Day 44', title_pt: 'Dia 44',
    exercises: [
      { ref: 'squeeze_8s', overrides: {"sets": 9} }, // 144s
      { ref: 'belly_breath_drop', overrides: {"sets": 16} }, // 160s
    ], // Total: 304s = 5.1 min
  },
  {
    day: 45, week: 7,
    title: 'Day 45', title_pt: 'Dia 45',
    exercises: [
      { ref: 'gentle_push_reset', overrides: {} }, // 150s
      { ref: 'child_pose_release', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 46, week: 7,
    title: 'Day 46', title_pt: 'Dia 46',
    exercises: [
      { ref: 'gentle_push_reset', overrides: {"sets": 10} }, // 100s
      { ref: 'belly_breath_drop', overrides: {"sets": 10} }, // 100s
      { ref: 'squeeze_8s', overrides: {"sets": 6} }, // 96s
    ], // Total: 296s = 4.9 min
  },
  {
    day: 47, week: 7,
    title: 'Day 47', title_pt: 'Dia 47',
    exercises: [
      { ref: 'pulsacao', overrides: {} }, // 160s
      { ref: 'child_pose_release', overrides: {"hold": 140} }, // 140s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 48, week: 7,
    title: 'Day 48', title_pt: 'Dia 48',
    exercises: [
      { ref: 'child_pose_release', overrides: {} }, // 150s
      { ref: 'gentle_push_reset', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 49, week: 7,
    title: 'Day 49', title_pt: 'Dia 49',
    exercises: [
      { ref: 'squeeze_8s', overrides: {"sets": 6} }, // 96s
      { ref: 'squeeze_5s', overrides: {"sets": 10} }, // 100s
      { ref: 'child_pose_release', overrides: {"hold": 104} }, // 104s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 50, week: 8,
    title: 'Day 50', title_pt: 'Dia 50',
    exercises: [
      { ref: 'squeeze_5s', overrides: {} }, // 150s
      { ref: 'pulsacao', overrides: {} }, // 160s
    ], // Total: 310s = 5.2 min
  },
  {
    day: 51, week: 8,
    title: 'Day 51', title_pt: 'Dia 51',
    exercises: [
      { ref: 'squeeze_8s', overrides: {"sets": 9} }, // 144s
      { ref: 'squeeze_5s', overrides: {"sets": 16} }, // 160s
    ], // Total: 304s = 5.1 min
  },
  {
    day: 52, week: 8,
    title: 'Day 52', title_pt: 'Dia 52',
    exercises: [
      { ref: 'squeeze_8s', overrides: {"sets": 6} }, // 96s
      { ref: 'pulsacao', overrides: {"sets": 3} }, // 92s
      { ref: 'squeeze_5s', overrides: {"sets": 11} }, // 110s
    ], // Total: 298s = 5.0 min
  },
  {
    day: 53, week: 8,
    title: 'Day 53', title_pt: 'Dia 53',
    exercises: [
      { ref: 'belly_breath_drop', overrides: {} }, // 150s
      { ref: 'pulsacao', overrides: {} }, // 160s
    ], // Total: 310s = 5.2 min
  },
  {
    day: 54, week: 8,
    title: 'Day 54', title_pt: 'Dia 54',
    exercises: [
      { ref: 'gentle_push_reset', overrides: {} }, // 150s
      { ref: 'pulsacao', overrides: {} }, // 160s
    ], // Total: 310s = 5.2 min
  },
  {
    day: 55, week: 8,
    title: 'Day 55', title_pt: 'Dia 55',
    exercises: [
      { ref: 'pulsacao', overrides: {"sets": 3} }, // 92s
      { ref: 'squeeze_5s', overrides: {"sets": 10} }, // 100s
      { ref: 'squeeze_8s', overrides: {"sets": 7} }, // 112s
    ], // Total: 304s = 5.1 min
  },
  {
    day: 56, week: 8,
    title: 'Day 56', title_pt: 'Dia 56',
    exercises: [
      { ref: 'pulsacao', overrides: {} }, // 160s
      { ref: 'squeeze_5s', overrides: {"sets": 14} }, // 140s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 57, week: 9,
    title: 'Day 57', title_pt: 'Dia 57',
    exercises: [
      { ref: 'squeeze_5s', overrides: {} }, // 150s
      { ref: 'gentle_push_reset', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 58, week: 9,
    title: 'Day 58', title_pt: 'Dia 58',
    exercises: [
      { ref: 'belly_breath_drop', overrides: {} }, // 150s
      { ref: 'pulsacao', overrides: {} }, // 160s
    ], // Total: 310s = 5.2 min
  },
  {
    day: 59, week: 9,
    title: 'Day 59', title_pt: 'Dia 59',
    exercises: [
      { ref: 'child_pose_release', overrides: {"hold": 100.0} }, // 100.0s
      { ref: 'squeeze_8s', overrides: {"sets": 6} }, // 96s
      { ref: 'pulsacao', overrides: {"sets": 3} }, // 92s
    ], // Total: 288.0s = 4.8 min
  },
  {
    day: 60, week: 9,
    title: 'Day 60', title_pt: 'Dia 60',
    exercises: [
      { ref: 'pulsacao', overrides: {} }, // 160s
      { ref: 'child_pose_release', overrides: {"hold": 140} }, // 140s
    ], // Total: 300s = 5.0 min
  },
];


export const monthMeta = {
  month: 2,
  program: 'weak_pf',
  phase: 'Foundation Strength',
  phase_pt: 'Forca da Base',
  days_range: [31, 60],
  session_target_seconds: 300,
};

export function resolveDay(dayNumber) {
  const dayData = days.find(d => d.day === dayNumber);
  if (!dayData) return null;
  return { ...dayData, exercises: dayData.exercises.map(ex => ({ ...exercises[ex.ref], ...ex.overrides })) };
}